import React from "react";
import { ThumbnailsBlock } from '../ThumbnailsBlock';

export const NewsBlock = ({ news, ...props }) => (
    <ThumbnailsBlock thumbnails={news} {...props} />
)